module.exports = __webpack_public_path__ + "img/adv.dae03156.png";